/**
 * Every category we support for exclusives.
 *
 * Note: On the backend, these are actually topics.
 */ export var ExclusiveCategory;
(function(ExclusiveCategory) {
    ExclusiveCategory["Adoptable"] = "adoptable";
    ExclusiveCategory["DigitalArt"] = "digital-art";
    ExclusiveCategory["GameArt"] = "game-art";
    ExclusiveCategory["MixedMedia"] = "mixed-media";
    ExclusiveCategory["Photography"] = "photography";
    ExclusiveCategory["Pinups"] = "pinups";
    ExclusiveCategory["TraditionalArt"] = "traditional-art";
    ExclusiveCategory["ThreeDArt"] = "three-d-art";
})(ExclusiveCategory || (ExclusiveCategory = {}));
/**
 * Our topic necoids mapped to the appropriate {@link ExclusiveCategory}.
 */ export const necoidToExclusiveCategory = {
    '17': "adoptable",
    '6': "digital-art",
    '9': "game-art",
    '1331': "mixed-media",
    '46': "photography",
    '214': "pinups",
    '5': "traditional-art",
    '10': "three-d-art"
};
/**
 * Our {@link ExclusiveCategory} enum mapped to the appropriate topic necoid.
 */ export const exclusiveCategoryToNecoid = {
    ["adoptable"]: '17',
    ["digital-art"]: '6',
    ["game-art"]: '9',
    ["mixed-media"]: '1331',
    ["photography"]: '46',
    ["pinups"]: '214',
    ["traditional-art"]: '5',
    ["three-d-art"]: '10'
};
/**
 * Takes a necoid (converted to a string, for typescript reasons) and returns the appropriate {@link ExclusiveCategory}.
 */ export function getExclusiveCategoryByNecoid(key) {
    return necoidToExclusiveCategory[key];
}
/**
 * Takes an {@link ExclusiveCategory} and returns the appropriate necoid.
 */ export function getNecoidByExclusiveCategory(key) {
    return exclusiveCategoryToNecoid[key];
}

//# sourceMappingURL=exclusives.js.map